var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<catalog-browser order-id=\"$ctrl.orderId\" retailer-id=\"$ctrl.order.retailerId\"></catalog-browser>";
var id1="order-details-catalogs.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;